(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  L.Control.MfButtonGrid = (function(superClass) {
    extend(MfButtonGrid, superClass);

    MfButtonGrid.prototype.options = {
      position: 'topleft',
      toolbars: []
    };


    /*
    toolbars: [
        { # Box/Group
            rows: [
                [ # Row
                     * Each object here defines a button / column in the row
    
                     * data name, symbol, toggle
                    { name: 'draw-poly-add', html: '<i class="drawicon-poly-green"></i>', toggle: true},
                ]
            ]
        },
        { # A second grid of buttons
            rows: []
        }
    ]
     */

    function MfButtonGrid() {
      this.tooltipButtonIsDisabled = bind(this.tooltipButtonIsDisabled, this);
      this.enableTooltipButton = bind(this.enableTooltipButton, this);
      this.disableTooltipButton = bind(this.disableTooltipButton, this);
      this.handleClick = bind(this.handleClick, this);
      this.toggleButton = bind(this.toggleButton, this);
      this.enableMapInteraction = bind(this.enableMapInteraction, this);
      this.disableMapInteraction = bind(this.disableMapInteraction, this);
      L.Control.MfButtonGrid.include(L.Mixin.Events);
      MfButtonGrid.__super__.constructor.call(this);
    }

    MfButtonGrid.prototype.onAdd = function(map) {
      var btn, container, control_cls, data_name, j, l, len, len1, len2, m, nbtn, ref, ref1, ref2, row, self, tb, txt, v;
      this.callbacks = {};
      this.buttons = {};
      this.outerMost = L.DomUtil.create('div', '');
      this.outer = L.DomUtil.create('div', '', this.outerMost);
      this.outerTooltips = L.DomUtil.create('div', '', this.outerMost);
      self = this;
      this._map = map;
      this.createTooltipButtons(self);
      ref = this.options.toolbars;
      for (j = 0, len = ref.length; j < len; j++) {
        tb = ref[j];
        control_cls = 'leaflet-control-buttongrid';
        container = L.DomUtil.create('div', control_cls + " leaflet-bar", this.outer);
        if (tb.style != null) {
          $(container).css(tb.style);
        }
        ref1 = tb.rows;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          v = ref1[l];
          row = this._addRow(container);
          for (m = 0, len2 = v.length; m < len2; m++) {
            btn = v[m];
            txt = (ref2 = btn.html) != null ? ref2 : btn.name;
            data_name = btn.name;
            this.callbacks[data_name] = [];
            nbtn = L.DomUtil.create('a', "clickable " + data_name + " pull-left", row);
            nbtn.innerHTML = "" + txt;
            if (btn.style != null) {
              $(nbtn).css(btn.style);
            }
            $(nbtn).data('drawName', data_name);
            this.buttons[data_name] = $(nbtn);
            $(nbtn).on('mouseover', (function(_this) {
              return function(e) {
                return _this.disableMapInteraction();
              };
            })(this));
            $(nbtn).on('mouseleave', (function(_this) {
              return function(e) {
                return _this.enableMapInteraction();
              };
            })(this));
            $(nbtn).on('click', function(e) {
              e.preventDefault();
              if ($(e.currentTarget).hasClass('leaflet-buttongrid-disabled')) {
                return;
              }
              self.handleClick($(e.currentTarget).data('drawName'), e);
              return false;
            });
            if ((btn.toggle != null) && btn.toggle) {
              this.addCallback(data_name, function(e, drawname) {
                return self.toggleButton(drawname);
              });
            } else {
              this.addCallback(data_name, function(e, drawname) {
                return self.toggleButton(drawname, false);
              });
            }
          }
        }
      }
      this.positionTooltipButtons();
      this.registerTooltipActions();
      return this.outerMost;
    };

    MfButtonGrid.prototype.disableMapInteraction = function() {
      App.map.touchZoom.disable();
      App.map.doubleClickZoom.disable();
      return App.map.scrollWheelZoom.disable();
    };

    MfButtonGrid.prototype.enableMapInteraction = function() {
      App.map.touchZoom.enable();
      App.map.doubleClickZoom.enable();
      return App.map.scrollWheelZoom.enable();
    };

    MfButtonGrid.prototype.toggleButton = function(btn, select) {
      if (select == null) {
        select = true;
      }
      this.deselectAllButtons();
      if (select) {
        return this.selectBtn(btn);
      }
    };

    MfButtonGrid.prototype.getButton = function(btn) {
      return this.buttons[btn];
    };

    MfButtonGrid.prototype.selectBtn = function(btn) {
      var addButton, button;
      button = this.buttons[btn];
      if (button != null) {
        button.addClass('leaflet-buttongrid-active');
      }
      if (btn === 'draw-poly-add' || btn === 'draw-poly-sub') {
        addButton = this.buttons['draw-poly-add'];
        this.positionTooltipButtonsPolygon(addButton);
      }
      if (btn === 'draw-rect-add' || btn === 'draw-rect-sub') {
        addButton = this.buttons['draw-rect-add'];
        this.positionTooltipButtonsRectangle(addButton);
      }
      if (btn === 'draw-circle-add' || btn === 'draw-circle-sub') {
        addButton = this.buttons['draw-circle-add'];
        return this.positionTooltipButtonsCircle(addButton);
      }
    };

    MfButtonGrid.prototype.deselectBtn = function(btn) {
      var button;
      button = this.buttons[btn];
      return button != null ? button.removeClass('leaflet-buttongrid-active') : void 0;
    };

    MfButtonGrid.prototype.deselectAllButtons = function() {
      var k, self;
      self = this;
      for (k in this.buttons) {
        this.deselectBtn(k);
      }
      $(this.finishButton).css({
        visibility: 'hidden'
      });
      $(this.deletePointButton).css({
        visibility: 'hidden'
      });
      return $(this.cancelButton).css({
        visibility: 'hidden'
      });
    };

    MfButtonGrid.prototype.disableBtn = function(btn) {
      var btns, button, i, j, len, results;
      btns = this._parseButtonSelector(btn);
      results = [];
      for (j = 0, len = btns.length; j < len; j++) {
        i = btns[j];
        button = this.buttons[i];
        this.deselectBtn(i);
        results.push(button != null ? button.addClass('leaflet-buttongrid-disabled') : void 0);
      }
      return results;
    };

    MfButtonGrid.prototype.enableBtn = function(btn) {
      var btns, button, i, j, len, results;
      btns = this._parseButtonSelector(btn);
      results = [];
      for (j = 0, len = btns.length; j < len; j++) {
        i = btns[j];
        button = this.buttons[i];
        results.push(button != null ? button.removeClass('leaflet-buttongrid-disabled') : void 0);
      }
      return results;
    };

    MfButtonGrid.prototype._parseButtonSelector = function(sel) {
      var i, j, k, len, multi, ref, result, v;
      result = [];
      if (sel === '*') {
        ref = this.buttons;
        for (k in ref) {
          v = ref[k];
          if (k !== 'draw-undo') {
            result.push(k);
          }
        }
      } else {
        multi = sel.split(',');
        for (j = 0, len = multi.length; j < len; j++) {
          i = multi[j];
          result.push(i);
        }
      }
      return result;
    };

    MfButtonGrid.prototype.handleClick = function(name, e) {
      var i, j, len, ref, results;
      ref = this.callbacks[name];
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        results.push(i(e, name, this.outer));
      }
      return results;
    };

    MfButtonGrid.prototype.addCallback = function(data_name, cb) {
      var btn, i, j, len, ref;
      btn = this._parseButtonSelector(data_name);
      for (j = 0, len = btn.length; j < len; j++) {
        i = btn[j];
        if ((ref = this.callbacks[i]) != null) {
          ref.push(cb);
        }
      }
      return cb;
    };

    MfButtonGrid.prototype.removeCallback = function(data_name, cb) {
      var ind, ref, ref1;
      ind = (ref = this.callbacks[data_name]) != null ? ref.indexOf(cb) : void 0;
      if (ind !== -1) {
        return (ref1 = this.callbacks[data_name]) != null ? ref1.splice(ind, 1) : void 0;
      }
    };

    MfButtonGrid.prototype._addRow = function(container) {
      var row;
      row = L.DomUtil.create('div', 'leaflet-buttongrid-row drawing-tools-layer', container);
      return row;
    };

    MfButtonGrid.prototype.disableTooltipButton = function(button) {
      if (this.noTooltipButtons) {
        return;
      }
      return $(button).find('a').attr('disabled', true);
    };

    MfButtonGrid.prototype.enableTooltipButton = function(button) {
      if (this.noTooltipButtons) {
        return;
      }
      return $(button).find('a').attr('disabled', false);
    };

    MfButtonGrid.prototype.registerTooltipActions = function() {
      if (this.noTooltipButtons) {
        return;
      }
      $(this.finishButton).on('click', (function(_this) {
        return function(e) {
          _this.current_tool.h._markers.pop().remove();
          _this.current_tool.h._poly._latlngs.pop();
          _this.current_tool.h._poly.redraw();
          if (_this.tooltipButtonIsDisabled(_this.finishButton)) {
            return;
          }
          _this.current_tool.h._finishShape();
          return _this.fire('mfdraw:poly-complete');
        };
      })(this));
      $(this.deletePointButton).on('click', (function(_this) {
        return function(e) {
          var ref;
          if (_this.tooltipButtonIsDisabled(_this.deletePointButton)) {
            return;
          }
          if (_this.current_tool.h._markers.length === 1) {
            _this.current_tool.disable();
            _this._drawPolygon();
          } else {
            _this.current_tool.h.deleteLastVertex();
            _this.current_tool.h._markers.pop().remove();
            _this.current_tool.h._poly._latlngs.pop();
            _this.current_tool.h._poly.redraw();
          }
          if (((ref = _this.current_tool.h._markers) != null ? ref.length : void 0) < 3) {
            return _this.disableTooltipButton(_this.finishButton);
          }
        };
      })(this));
      return $(this.cancelButton).on('click', (function(_this) {
        return function(e) {
          _this.current_tool.disable();
          return _this.deselectAllButtons();
        };
      })(this));
    };

    MfButtonGrid.prototype.positionTooltipButtons = function() {
      if (this.noTooltipButtons) {
        return;
      }
      $(this.outerTooltips).css({
        position: 'absolute',
        top: $(this.outer).position().top + 'px',
        left: ($(this.outer).position().left + 45) + 'px'
      });
      $(this.finishButton).css({
        visibility: 'hidden'
      });
      $(this.deletePointButton).css({
        visibility: 'hidden',
        position: 'absolute',
        top: $(this.finishButton).position().top + 'px',
        left: ($(this.finishButton).position().left + 67) + 'px'
      });
      return $(this.cancelButton).css({
        visibility: 'hidden',
        position: 'absolute',
        top: '0px',
        left: ($(this.deletePointButton).position().left + 167) + 'px'
      });
    };

    MfButtonGrid.prototype.createTooltipButtons = function() {
      var innerCancelButton, innerDeletePointButton, innerFinishButton, tooltipContainer;
      if (this.noTooltipButtons) {
        return;
      }
      tooltipContainer = L.DomUtil.create('ul', "pull-right tooltip-buttons-container", this.outerTooltips);
      this.finishButton = L.DomUtil.create('li', 'tooltip-buttons', tooltipContainer);
      innerFinishButton = L.DomUtil.create('a', 'pull-left clickable tooltip-button tooltip-button-left', this.finishButton);
      innerFinishButton.title = 'Finish';
      innerFinishButton.innerHTML = 'Finish';
      this.deletePointButton = L.DomUtil.create('li', 'tooltip-buttons', tooltipContainer);
      innerDeletePointButton = L.DomUtil.create('a', 'pull-left clickable tooltip-button tooltip-button-middle', this.deletePointButton);
      innerDeletePointButton.title = 'Delete Last Point';
      innerDeletePointButton.innerHTML = 'Delete Last Point';
      this.cancelButton = L.DomUtil.create('li', 'tooltip-buttons', tooltipContainer);
      innerCancelButton = L.DomUtil.create('a', 'pull-left clickable tooltip-button tooltip-button-right tooltip-button-end', this.cancelButton);
      innerCancelButton.title = 'Cancel';
      innerCancelButton.innerHTML = 'Cancel';
      $(this.deletePointButton).on('mouseover', (function(_this) {
        return function(e) {
          return _this.disableMapInteraction();
        };
      })(this));
      $(this.deletePointButton).on('mouseleave', (function(_this) {
        return function(e) {
          return _this.enableMapInteraction();
        };
      })(this));
      $(this.finishButton).on('mouseover', (function(_this) {
        return function(e) {
          return _this.disableMapInteraction();
        };
      })(this));
      $(this.finishButton).on('mouseleave', (function(_this) {
        return function(e) {
          return _this.enableMapInteraction();
        };
      })(this));
      $(this.cancelButton).on('mouseover', (function(_this) {
        return function(e) {
          return _this.disableMapInteraction();
        };
      })(this));
      return $(this.cancelButton).on('mouseleave', (function(_this) {
        return function(e) {
          return _this.enableMapInteraction();
        };
      })(this));
    };

    MfButtonGrid.prototype.tooltipButtonIsDisabled = function(button) {
      return $(button).find('a').is('[disabled=disabled]');
    };

    MfButtonGrid.prototype.positionTooltipButtonsPolygon = function(addButton) {
      if (this.noTooltipButtons) {
        return;
      }
      $(this.cancelButton).removeClass('tooltip-button-left');
      $(this.finishButton).css({
        visibility: 'visible'
      });
      $(this.deletePointButton).css({
        visibility: 'visible'
      });
      $(this.cancelButton).css({
        visibility: 'visible',
        position: 'absolute',
        top: '0px',
        left: ($(addButton).position().left + 167) + 'px'
      });
      $(this.cancelButton).find('a').removeClass('tooltip-button-left');
      return $(this.cancelButton).find('a').addClass('tooltip-button-end');
    };

    MfButtonGrid.prototype.positionTooltipButtonsRectangle = function(addButton) {
      if (this.noTooltipButtons) {
        return;
      }
      $(this.cancelButton).addClass('tooltip-button-left');
      $(this.cancelButton).css({
        visibility: 'visible'
      });
      $(this.cancelButton).css({
        position: 'absolute',
        top: $(addButton).position().top + 31 + 'px',
        left: ($(addButton).position().left + 25) + 'px'
      });
      $(this.cancelButton).find('a').addClass('tooltip-button-left');
      return $(this.cancelButton).find('a').removeClass('tooltip-button-end');
    };

    MfButtonGrid.prototype.positionTooltipButtonsCircle = function(addButton) {
      if (this.noTooltipButtons) {
        return;
      }
      $(this.cancelButton).css({
        visibility: 'visible'
      });
      $(this.cancelButton).css({
        position: 'absolute',
        top: $(addButton).position().top + 62 + 'px',
        left: ($(addButton).position().left + 25) + 'px'
      });
      $(this.cancelButton).find('a').addClass('tooltip-button-left');
      return $(this.cancelButton).find('a').removeClass('tooltip-button-end');
    };

    return MfButtonGrid;

  })(L.Control);

}).call(this);
